module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/06f3b7203e7424adb8a255f708d690b1.png";